/* eslint-disable @typescript-eslint/no-non-null-assertion */
import type { Repository } from "@octopusdeploy/octopus-server-client";
import { projectsRoute } from "@octopusdeploy/portal-routes";
import * as React from "react";
import AreaTitle from "~/components/AreaTitle/index";
import type { DataBaseComponentState } from "~/components/DataBaseComponent/index";
import { DataBaseComponent } from "~/components/DataBaseComponent/index";
import PaperLayout from "~/components/PaperLayout/index";
import { ProjectTriggerRedirect } from "~/components/RootRoutes/ProjectTriggerRedirect";
import { repository } from "../../clientInstance";
import routeLinks from "../../routeLinks";
import InternalRedirect from "../Navigation/InternalRedirect/InternalRedirect";
interface ProjectChildRedirectState extends DataBaseComponentState {
    redirectTo: string;
}
interface ProjectChildRedirectProps {
    spaceId: string;
    getProjectId: (repository: Repository) => Promise<string>;
    getRedirectPath: (projectId: string) => string;
}
class ProjectChildRedirect extends DataBaseComponent<ProjectChildRedirectProps, ProjectChildRedirectState> {
    constructor(props: ProjectChildRedirectProps) {
        super(props);
        this.state = {
            redirectTo: null!,
        };
    }
    async componentDidMount() {
        await this.doBusyTask(async () => {
            const projectId = await this.props.getProjectId(repository);
            const redirectTo = this.props.getRedirectPath(projectId);
            this.setState({
                redirectTo,
            });
        });
    }
    render() {
        const redirectTo = this.state.redirectTo;
        if (!redirectTo) {
            return (<main>
                    <AreaTitle link={projectsRoute.generateUrl({ spaceId: this.props.spaceId })} title="Projects"/>
                    <PaperLayout busy={this.state.busy} fullWidth={true} errors={this.errors}/>
                </main>);
        }
        return <InternalRedirect push={false} to={{ pathname: redirectTo }}/>;
    }
    static displayName = "ProjectChildRedirect";
}
export const ReleaseRedirect: React.FC<{
    spaceId: string;
    releaseId: string;
}> = (props) => {
    return <ProjectChildRedirect spaceId={props.spaceId} getProjectId={async (r) => (await r.Releases.get(props.releaseId)).ProjectId} getRedirectPath={(projectId: string) => routeLinks.project(projectId).release(props.releaseId).root}/>;
};
ReleaseRedirect.displayName = "ReleaseRedirect"
export const TriggerRedirect: React.FC<{
    spaceId: string;
    triggerId: string;
}> = (props) => {
    return <ProjectTriggerRedirect spaceId={props.spaceId} triggerId={props.triggerId}/>;
};
TriggerRedirect.displayName = "TriggerRedirect"
export const ChannelRedirect: React.FC<{
    spaceId: string;
    channelId: string;
}> = (props) => {
    return <ProjectChildRedirect spaceId={props.spaceId} getProjectId={async (r) => (await r.Channels.get(props.channelId)).ProjectId} getRedirectPath={(projectId: string) => routeLinks.project(projectId).channel(props.channelId)}/>;
};
ChannelRedirect.displayName = "ChannelRedirect"
export const RunbookRedirect: React.FC<{
    spaceId: string;
    runbookId: string;
}> = (props) => {
    return <ProjectChildRedirect spaceId={props.spaceId} getProjectId={async (r) => (await r.Runbooks.get(props.runbookId)).ProjectId} getRedirectPath={(projectId: string) => routeLinks.project(projectId).operations.runbook(props.runbookId).root}/>;
};
RunbookRedirect.displayName = "RunbookRedirect"
